// extracted by css-extract-rspack-plugin
var _1 = "container-Emgck7";
export { _1 as "container" }
